import Script from "next/script";

import { ahrefsAnalyticsDataKey } from "@app/constants";

export const AhrefsAnalyticsScript = () =>
  ahrefsAnalyticsDataKey ? (
    <Script
      strategy="afterInteractive"
      src="https://analytics.ahrefs.com/analytics.js"
      data-key={ahrefsAnalyticsDataKey}
    />
  ) : null;
